import React, { useState } from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';


function SortableItem({ id, label, checked, onToggle }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className="flex items-center justify-between p-2 bg-white border rounded shadow-sm transition-all duration-200 hover:bg-gray-50"
    >
      <div className="flex items-center">
        <span {...listeners} className="cursor-grab mr-2 text-gray-400 hover:text-gray-600">
          <GripVertical size={16} />
        </span>
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onToggle(id)}
          className="mr-2"
        />
        <span className="truncate">{label}</span>
      </div>
    </div>
  );
}

const ColumnManager = ({ allColumns,skipFields,selectedColumns, onUpdate, onClose,columnMappings }) => {
  //const [selected, setSelected] = useState([...selectedColumns]);
  const [selected, setSelected] = useState(
    selectedColumns.filter(col => !skipFields.includes(col))
  );
  const getColumnLabel = (col) =>
    columnMappings[col] || col.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

    const toggleColumn = (colName) => {
        setSelected((prev) =>
        prev.includes(colName) ? prev.filter(c => c !== colName) : [...prev, colName]
        );
    };

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = selected.indexOf(active.id);
      const newIndex = selected.indexOf(over.id);
      setSelected((items) => arrayMove(items, oldIndex, newIndex));
    }
  };

  const applyChanges = () => {
    onUpdate(selected);
    onClose();
  };

  // const unselected = allColumns
  //   .map(col => col.column_name)
  //   .filter(col => !selected.includes(col));
  const unselected = allColumns
  .map(col => col.column_name)
  .filter(
    col => !selected.includes(col) && !skipFields.includes(col)
  );
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
      <div className="bg-white rounded shadow w-96 max-h-[80vh] flex flex-col animate-fadeIn">
        <div className="sticky top-0 bg-white z-10 pb-2 pt-3 px-1 border-b">
            <h2 className="pl-3 pr-3 text-lg font-semibold">Manage Columns</h2>
        </div>
        <div className="space-y-2 transition-all overflow-y-auto px-1 mt-2 flex-1">

          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={selected} strategy={verticalListSortingStrategy}>
              {selected.map((colId) => {
                const colMeta = allColumns.find(c => c.column_name === colId);
                return (
                  <SortableItem
                    key={colId}
                    id={colId}
                    label={getColumnLabel(colMeta?.label ||  colMeta?.column_name)}
                    checked={true}
                    onToggle={toggleColumn}
                  />
                );
              })}
            </SortableContext>
          </DndContext>

          {unselected.map(colId => {
            const colMeta = allColumns.find(c => c.column_name === colId);
            return (
              <div
                key={colId}
                className="flex items-center p-2 bg-gray-50 border rounded shadow-sm transition hover:bg-gray-100"
              >
                <input
                  type="checkbox"
                  checked={false}
                  onChange={() => toggleColumn(colId)}
                  className="mr-2"
                />
                <span className="truncate">{getColumnLabel(colMeta?.label ||  colMeta?.column_name)}</span>
              </div>
            );
          })}
        </div>

       <div className="sticky bottom-0 left-0 right-0 bg-white px-3 pt-3 pb-3 border-t mt-2 flex justify-end gap-2">
          <button onClick={onClose} className="text-sm px-3 py-1 border rounded">Cancel</button>
          <button onClick={applyChanges} className="text-sm px-3 py-1 bg-blue-600 text-white rounded">Apply</button>
        </div>
      </div>
    </div>
  );
};

export default ColumnManager;